import { __spreadArray } from "tslib";
import { reduxKey } from './constants';
import { GallectionType } from '../types/gallection';
import { getGallectionStreamId, isGallectionManageable, getBrowseDeviationStreamId, getGallectionDeviationStreamId, getCustomDeviationSetStreamId, areGallectionContentsManageable, getPostStreamIdFromMediaSource, getTierStreamId, getTierDeviationsStreamId, } from './helpers';
import { selectors } from '../Stream';
import { getDenormalizedDataEntityById, getDenormalizedDataEntitiesByIds, } from '../redux/entities/selectors';
import { galleryFolderSchema, collectionFolderSchema, } from '../redux/normalizr/schemas/folder';
import { MediaSourceType } from './types';
import { SCRAPS_FOLDER_ID } from '@wix/da-url';
import { getDeviationsByIds, getDeviationById, } from '../redux/deviations/selectors';
import { DeviationResourceType } from '../types/deviation';
export var getMode = function (state) { return state[reduxKey].mode; };
export var getCurrentMediaSource = function (state) {
    return state[reduxKey].currentMediaSource;
};
export var getMediaSourceTypes = function (state) { return state[reduxKey].mediaSourceTypes; };
export var getWithMediaSourceSelector = function (state) {
    return state[reduxKey].withMediaSourceSelector;
};
export var getCurrentFolderId = function (state) { return state[reduxKey].currentFolderId; };
export var getCurrentTierId = function (state) { return state[reduxKey].currentTierId; };
export var getCurrentTier = function (state) {
    var tierId = getCurrentTierId(state);
    if (tierId) {
        return getTierDeviationById(state, tierId);
    }
};
export var getTierDeviationById = function (state, tierId) {
    return getDeviationById(state, DeviationResourceType.TIER + "-" + tierId);
};
export var getCurrentSubfolderId = function (state) {
    return state[reduxKey].currentSubfolderId;
};
export var getSearchInput = function (state) { return state[reduxKey].searchInput; };
export var getSearchQuery = function (state) { return state[reduxKey].searchQuery; };
export var getAllowedDeviationTypes = function (state) {
    return state[reduxKey].allowedDeviationTypes;
};
export var getAllowedDeviationResourceTypes = function (state) {
    return state[reduxKey].allowedDeviationResourceTypes;
};
export var getAllowGifs = function (state) { return state[reduxKey].allowGifs; };
export var getAllowPremium = function (state) { return state[reduxKey].allowPremium; };
export var getAllowInTierContent = function (state) {
    return state[reduxKey].allowInTierContent;
};
export var getAllowMature = function (state) { return state[reduxKey].allowMature; };
export var getAllowUploads = function (state) { return state[reduxKey].allowUploads; };
export var getAllowMultipleUploads = function (state) {
    return state[reduxKey].allowMultipleUploads;
};
export var getIgnoreDeviationIds = function (state) {
    return state[reduxKey].ignoreDeviationIds;
};
export var getMinDeviationWidth = function (state) { return state[reduxKey].minDeviationWidth; };
export var getMinDeviationHeight = function (state) {
    return state[reduxKey].minDeviationHeight;
};
export var getCurrentGallection = function (state) {
    var currentFolderId = getCurrentFolderId(state);
    return getGallectionById(state, currentFolderId);
};
export var getCurrentSubfolder = function (state) {
    var currentSubfolderId = getCurrentSubfolderId(state);
    return getGallectionById(state, currentSubfolderId);
};
export var getCurrentStreamId = function (state) {
    var mediaSource = getCurrentMediaSource(state);
    var streamId;
    switch (mediaSource) {
        case MediaSourceType.GALLERY:
        case MediaSourceType.COLLECTION:
            var folderId = getCurrentFolderId(state);
            if (folderId) {
                var subfolderId = getCurrentSubfolderId(state);
                streamId = getGallectionDeviationStreamId(mediaSource, subfolderId || folderId);
            }
            else {
                streamId = getGallectionStreamId(mediaSource);
            }
            break;
        case MediaSourceType.POLL:
        case MediaSourceType.STATUS:
        case MediaSourceType.JOURNAL:
        case MediaSourceType.POSTS:
            streamId = getPostStreamIdFromMediaSource(mediaSource);
            break;
        case MediaSourceType.BROWSE:
            streamId = getBrowseDeviationStreamId(getSearchQuery(state));
            break;
        case MediaSourceType.CUSTOM_SET:
            streamId = getCustomDeviationSetStreamId();
            break;
        case MediaSourceType.TIER_DEVIATIONS:
        case MediaSourceType.TIER_POSTS:
            var tierId = getCurrentTierId(state);
            streamId = getTierDeviationsStreamId(mediaSource, tierId);
            break;
        default:
    }
    return streamId;
};
export var getCurrentStreamItems = function (state) {
    var streamId = getCurrentStreamId(state);
    return selectors.getItems(state, streamId);
};
export var getGallectionById = function (state, folderId) {
    var currentMediaSource = getCurrentMediaSource(state);
    var gallectionSchema = currentMediaSource === GallectionType.COLLECTION
        ? collectionFolderSchema
        : galleryFolderSchema;
    return getDenormalizedDataEntityById(state, gallectionSchema, folderId);
};
export var getIsShowingNewGallectionPopup = function (state) {
    return state[reduxKey].isShowingNewGallectionPopup;
};
export var getIsShowingAddDeviationsPopup = function (state) {
    return state[reduxKey].isShowingAddDeviationsPopup;
};
export var getIsOnlyPaidFoldersSelector = function (state) {
    return state[reduxKey].onlyNewPaidFolders;
};
export var getSelectionLimit = function (state) { return state[reduxKey].selectionLimit; };
export var getSelectedDeviationIds = function (state) {
    return state[reduxKey].selectedDeviationEntityIds;
};
export var getAllGallections = function (state) {
    var mediaSource = getCurrentMediaSource(state);
    var topLevelGallectionIds = getTopLevelGallectionIds(state);
    var allGallectionIds = [];
    topLevelGallectionIds.forEach(function (topLevelGallectionId) {
        var subfoldersStreamId = getGallectionStreamId(mediaSource, topLevelGallectionId);
        var subfoldersIds = selectors.getItems(state, subfoldersStreamId);
        allGallectionIds = __spreadArray(__spreadArray(__spreadArray([], allGallectionIds, true), [
            topLevelGallectionId
        ], false), subfoldersIds, true);
    });
    var gallectionSchema = mediaSource === MediaSourceType.COLLECTION
        ? collectionFolderSchema
        : galleryFolderSchema;
    var allGallections = getDenormalizedDataEntitiesByIds(state, gallectionSchema, allGallectionIds);
    return allGallections;
};
export var getTopLevelGallectionIds = function (state) {
    var mediaSource = getCurrentMediaSource(state);
    var streamId = getGallectionStreamId(mediaSource);
    var topLevelGallectionIds = selectors.getItems(state, streamId);
    return topLevelGallectionIds;
};
export var hasGallectionsToCopyOrMoveTo = function (state, currentFolderId) {
    return !!getTopLevelGallections(state).filter(function (gallection) {
        return areGallectionContentsManageable(gallection) &&
            gallection.folderId !== currentFolderId;
    }).length;
};
export var getTopLevelGallections = function (state) {
    var mediaSource = getCurrentMediaSource(state);
    var streamId = getGallectionStreamId(mediaSource);
    var gallectionSchema = mediaSource === MediaSourceType.COLLECTION
        ? collectionFolderSchema
        : galleryFolderSchema;
    var gallections = getDenormalizedDataEntitiesByIds(state, gallectionSchema, selectors.getItems(state, streamId));
    return gallections;
};
export var getTiers = function (state) {
    var streamId = getTierStreamId();
    var streamItems = selectors.getItems(state, streamId);
    var tiers = getDeviationsByIds(state, streamItems);
    return tiers;
};
export var getFeaturedFolder = function (state) {
    return (getTopLevelGallections(state) || []).find(function (folder) { return folder.name === 'Featured'; });
};
export var getCurrentGallectionSubfolders = function (state) {
    var currentGallection = getCurrentGallection(state);
    if (!currentGallection) {
        return [];
    }
    return getSubfoldersByParentId(state, currentGallection.folderId);
};
export var getSubfoldersByParentId = function (state, parentId) {
    var mediaSource = getCurrentMediaSource(state);
    var streamId = getGallectionStreamId(mediaSource, parentId);
    var gallectionSchema = mediaSource === MediaSourceType.COLLECTION
        ? collectionFolderSchema
        : galleryFolderSchema;
    var gallectionIds = selectors.getItems(state, streamId);
    var gallections = getDenormalizedDataEntitiesByIds(state, gallectionSchema, gallectionIds);
    return gallections;
};
export var getTotalDeviationsCountByFolderId = function (state, folderId) {
    var folder = getGallectionById(state, folderId);
    var subfolders = getSubfoldersByParentId(state, folderId);
    var subfolderDeviationsCount = subfolders
        ? subfolders.reduce(function (prevValue, subfolder) { return prevValue + subfolder.size; }, 0)
        : 0;
    return folder.size + subfolderDeviationsCount;
};
// Be aware this is not how it's stored on the BE e.g.:
// * All is an artificial folder that doesn't really exist
// * Scraps goes last only in the UI, on the BE it takes the first spot
export var getNonManageablePrependedGallectionsCount = function (state) {
    var gallections = getTopLevelGallections(state);
    var currentFolderId = getCurrentFolderId(state);
    if (!gallections ||
        currentFolderId // there's no non-manageable gallections on subfolder level
    ) {
        return 0;
    }
    return gallections.filter(function (gallection) {
        return !isGallectionManageable(gallection) &&
            gallection.folderId !== SCRAPS_FOLDER_ID;
    } // Scraps is an exception -- it always goes last
    ).length;
};
export var streamHasScrapsFolder = function (state, streamId) {
    var gallectionIds = selectors.getItems(state, streamId);
    return gallectionIds.some(function (id) { return id === SCRAPS_FOLDER_ID; });
};
//# sourceMappingURL=selectors.js.map